import { create } from 'zustand'

export interface ITurboStore {
  isTurbo: boolean
}

export const useTurboStore = create<ITurboStore>(() => ({
  isTurbo: false,
}))
